import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'fixed',
    left: '6.25rem',
    right: 0,
    top: '4.375rem',
    boxShadow: '0 0.0625rem 0 0 #e4e7eb',
    height: '4.375rem',
    padding: '0 0 0 3.438rem',
    backgroundColor: theme.palette.font.white,
    zIndex: '999',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.25rem',
    color: theme.palette.primary.main,
    fontWeight: '500',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  icon: {
    fontSize: '1rem',
    marginRight: '0.5rem',
  },
}));

export default function Header({ text, path, id }) {
  const classes = useStyles();

  return (
    <div className={classes.head}>
      <Link id={id}   className={classes.link} to={path}>
        <ArrowLeftIcon className={classes.icon} />
        {text}
      </Link>
    </div>
  );
}
